import styled from "@emotion/styled";

import { Box, Flex } from "@/components/layout/flexbox";
import { ProLink } from "@/components/pieces/Pro";
import { BRAND_PURPLE } from "@/css/constants";

export function CTAMini() {
  return (
    <StyledCTA
      px={36}
      py={24}
      alignItems="center"
      justifyContent="space-between"
      flexDirection={["column", "row"]}
      textAlign={["center", "left"]}
    >
      <h3 className="m0">
        <Box fontSize={24} mr={[0, 36]} mb={[24, 0]}>
          Your intro session is only $29. Satisfaction guaranteed.
        </Box>
      </h3>
      <ProLink
        width="212px"
        to={`/match?type=find%20my%20agent%20button&source=${encodeURIComponent(
          "pro page",
        )}`}
      >
        <Flex py={1} fontSize={20} justifyContent="center">
          Find My Coach
        </Flex>
      </ProLink>
    </StyledCTA>
  );
}

const StyledCTA = styled(Flex)`
  background: ${BRAND_PURPLE};
  color: #fff;
  border-radius: 8px;
`;
